import React, { forwardRef } from 'react';
import { ReactComponent as BookingIcon } from '@/assets/icons/ri-calendar-check-line.svg';
import { ReactComponent as RefundIcon } from '@/assets/icons/ri-refund-2-line.svg';
import { RefType } from '@/components/common/Button/types';
import { ModalHeader, ModalBody } from '@/components/common/Modal/types';
import { getRefundDetail } from '@/store/refund-detail/action';
import { updateNotificationItem } from '@/store/notifications/action';
import { isYesterday } from '@/utils';

const getTimeDifferenceFromEpoch = (epoch) => {
  const now = Date.now();
  const diffInSeconds = Math.floor((now - epoch) / 1000);
  if (diffInSeconds < 60) {
    return `${diffInSeconds} secs`;
  }
  if (diffInSeconds < 3600) {
    const diffInMins = Math.floor(diffInSeconds / 60);
    return `${diffInMins} mins`;
  }
  const diffInHours = Math.floor(diffInSeconds / 3600);
  return `${diffInHours} hours`;
}

const NotificationItem = forwardRef<RefType, NotificationItemProps>(({
                                                                       id,
                                                                       eventId,
                                                                       eventType,
                                                                       eventCreatedAt,
                                                                       description,
                                                                       customerName,
                                                                       date,
                                                                       navigate,
                                                                       dispatch,
                                                                       isRead,
                                                                       setShow
                                                                     }: NotificationItemProps) => (
  <div onClick={() => {
    setShow(false)
    dispatch(updateNotificationItem(id)).then((res) => {
      if (!res.error) {
        if (eventType === 'BOOKING') {
          navigate(`/dashboard/booking/${eventId}/edit`)
        }
        else {
          let refundCustomId
          dispatch(getRefundDetail(eventId)).then(refundDetail => {
            refundCustomId = refundDetail.payload?.custom_id;
            navigate(`/dashboard/refund?search=${refundCustomId}`)
          })
        }
      }
    })
  }}
       role='button'
       tabIndex={0}
       onKeyDown={() => {
       }} className="flex items-center justify-between py-2 px-3">
    <div className="flex items-center gap-2 isolate">
      {eventType === 'BOOKING' &&
			<div className='flex relative items-center justify-center bg-blue-subtle h-7 w-7 rounded'>
				<BookingIcon />
				<div className='absolute top-0 right-0 -mt-1 -mr-1'>
          {!isRead && <div className='w-2 h-2 bg-red-primary rounded-full' />}
				</div>
			</div>}
      {eventType === 'REFUND' &&
			<div className='flex relative items-center justify-center bg-red-subtle h-7 w-7 rounded'>
				<RefundIcon />
				<div className='absolute top-0 right-0 -mt-1 -mr-1'>
          {!isRead && <div className='w-2 h-2 bg-red-primary rounded-full' />}
				</div>
			</div>}
      <div className="flex relative gap-1">
        <p className="font-bold text-sm">{customerName}</p>
        <p className="text-sm">{description}</p>
      </div>
    </div>
    {date === 'today' && <p className='text-small text-grey-dark'>{`${getTimeDifferenceFromEpoch(new Date(eventCreatedAt))}`}</p>}
    {date === 'yesterday' && <p className='text-small text-grey-dark'>{`${new Date(eventCreatedAt).getHours()}:${new Date(eventCreatedAt).getMinutes()}`}</p>}
  </div>
))

export const renderNotificationHeader: ModalHeader = {
  title: 'Notification'
}
export const renderNotificationBody = (notificationItem, navigate, dispatch: Function, setShow: Function): ModalBody => ({
  children: (
    <div className="flex flex-col w-full p-0 gap-8 mt-8">
      {!!notificationItem.filter(item => !isYesterday(item.event_created_at))?.length &&
			<div className="w-full flex flex-col gap-8">
				<div className='flex flex-col w-full py-0 px-4 gap-3'>
					<p className='font-medium text-xs'>Today</p>
					<div className='flex flex-col gap-1'>
            {notificationItem.map((item) => !isYesterday(item.event_created_at) &&
							<NotificationItem key={item.id}
																id={item.id}
																eventId={item.event_id}
																eventType={item.event_type}
																eventCreatedAt={item.event_created_at}
																description={item.description}
																customerName={item.customer_name}
																date='today'
																navigate={navigate}
																dispatch={dispatch}
																isRead={item.is_read}
                                setShow={setShow} />,
            )}
					</div>
				</div>
				<div className='w-full border-b border-grey-line-subtle' />
			</div>
      }
      {!!notificationItem.filter(item => isYesterday(item.event_created_at))?.length &&
			<div className="flex flex-col w-full py-0 px-4 gap-3">
				<p className="font-medium text-xs">Yesterday</p>
				<div className="flex flex-col gap-1">
          {notificationItem.map((item) => !!isYesterday(item.event_created_at) &&
						<NotificationItem key={item.id}
															id={item.id}
															eventId={item.event_id}
															eventType={item.event_type}
															eventCreatedAt={item.event_created_at}
															description={item.description}
															customerName={item.customer_name}
															date='yesterday'
															navigate={navigate}
															dispatch={dispatch}
															isRead={item.is_read}
                              setShow={setShow}/>
          )}
				</div>
			</div>}
    </div>
  )
})
